<template>
  <div class="content bg8">
      <div class="explore-programs-dropdown" style="text-align:center;padding:24px 16px 18px 16px;background:#fff;border-radius:12px;box-shadow:0 2px 8px 0 rgba(191,0,255,0.04);">
        <label for="program-select" class="dropdown-label" style="font-weight:600;color:#7a4fa3;font-size:1.1rem;margin-bottom:10px;display:block;">Explore Internship Programs</label>
        <select id="program-select" class="program-select" @change="onProgramChange" :value="$route.path">
          <option value="/digital-marketing-internship">Digital Marketing</option>
          <option value="/social-media-marketing-internship">Social Media Marketing</option>
          <option value="/content-creation-internship">Content Creation and Copywriting</option>
          <option value="/website-design-internship">Website Design</option>
          <option value="/data-analytics-internship">Data Analytics and BI</option>
          <option value="/graphic-design-internship">Graphic Design</option>
        </select>
      </div>
      <div class="middled">
        <div class="button-row">
          <a href="https://forms.gle/sgqWzHuRMRCzCV6q6" target="_blank" rel="nofollow">
            <button class="wide" style="background: #fff; color: #BF00FF; border: 1px solid #BF00FF;">Company Application</button>
          </a>
          <a href="https://forms.gle/gv7FWmgVsKKPBfhX7" target="_blank" rel="nofollow">
            <button class="wide" style="background: #fff; color: #BF00FF; border: 1px solid #BF00FF;">Intern Application</button>
          </a>
        </div>

        <div class="basehero">
            <h1>Content Creation &amp; Copywriting Internship Program</h1>
            <h2 class="section">Tell Your Story. Build Your Brand.</h2>
            <p>
            Every great brand has a voice. The Foclarity Content Creation and Copywriting Internship Program connects startups with student writers eager to craft content that drives action, builds trust, and tells your unique story.
            </p>
            <p>
            Startups get consistent, compelling content across blogs, emails, websites, and more—written by talented interns who are guided by marketing best practices. Interns gain real-world writing experience that goes beyond essays and into strategy, conversion, and creativity.
            </p>
            <hr>
            <h3>For Startups:</h3>
            <strong>Writers Who Understand Your Brand and Your Audience</strong>
            <p>
            Need content that actually moves the needle? Our interns are trained to write with purpose—whether you need thought leadership, product copy, or a compelling brand voice.
            </p>
            <ul>
            <li>A team of student copywriters matched to your industry and style</li>
            <li>SEO-informed blog posts, landing pages, and website copy</li>
            <li>Engaging emails and newsletters designed to convert</li>
            <li>Strategic messaging aligned with your brand tone and goals</li>
            <li>Regular drafts, edits, and approvals with guided oversight</li>
            </ul>
            <p>You get the words that grow your business—we handle the writing team that makes it happen.</p>
            <hr>
            <h3>For Interns:</h3>
            <strong>Write, Publish, Learn—and Get Paid in Experience</strong>
            <p>
            This program turns passionate writers into confident content creators. You’ll collaborate with startups to produce live content for real audiences—and build a professional portfolio in the process.
            </p>
            <ul>
            <li>Experience writing blogs, website pages, email campaigns, and more</li>
            <li>Exposure to SEO principles, tone of voice, and content strategy</li>
            <li>Training in tools like Grammarly, Google Docs, Notion, and Surfer SEO</li>
            <li>Mentorship and feedback from marketing professionals</li>
            <li>A published body of work to show off to employers and clients</li>
            </ul>
            <blockquote style="margin: 24px 20%; font-style: italic; color: #7a4fa3; border-left: 4px solid #BF00FF; padding-left: 16px;">
            “Writing for a real brand made me see how much strategy goes into good copy. Now I feel like a marketer—not just a writer.”<br>
            <span style="font-size: 0.95em; color: #41037b;">— Former Copywriting Intern</span>
            </blockquote>
            <hr>
            <h3>What You’ll Work On</h3>
            <ul>
            <li>Blog and article writing for thought leadership and SEO</li>
            <li>Website and landing page copy for clarity and conversion</li>
            <li>Email newsletters and drip campaign content</li>
            <li>Messaging frameworks and brand storytelling</li>
            <li>Keyword research and optimization for search visibility</li>
            </ul>
            <hr>
            <h3>How It Works</h3>
            <ol>
            <li><strong>Apply</strong>: Students and startups submit a quick application</li>
            <li><strong>Match</strong>: We pair interns and companies based on voice, industry, and needs</li>
            <li><strong>Kick Off</strong>: Start the collaboration with a kickoff call and shared content plan</li>
            <li><strong>Create &amp; Iterate</strong>: Write, edit, publish, and refine—together</li>
            </ol>
            <hr>
            <h3>Ready to Find Your Voice?</h3>
            <p>
            Whether you're a founder who needs help telling your story—or a writer who wants to turn passion into a portfolio—this is your opportunity.
            </p>
            <div class="button-row">
            <a href="https://forms.gle/sgqWzHuRMRCzCV6q6" target="_blank" rel="nofollow">
                <button class="wide" style="background: #fff; color: #BF00FF; border: 1px solid #BF00FF;">Company Application</button>
            </a>
            <a href="https://forms.gle/gv7FWmgVsKKPBfhX7" target="_blank" rel="nofollow">
                <button class="wide" style="background: #fff; color: #BF00FF; border: 1px solid #BF00FF;">Intern Application</button>
            </a>
            </div>
        </div>
        <div class="explore-programs" style="text-align:center;padding:32px 16px 24px 16px;background:#f7f2fa;border-radius:12px;box-shadow:0 2px 8px 0 rgba(191,0,255,0.04);">
            <h2 style="color:#7a4fa3;font-size:1.3rem;margin-bottom:16px;">Explore More Internship Programs</h2>
            <ul class="explore-list" style="list-style:none;padding:0;margin:0;">
            <li style="margin:10px 0;"><router-link to="/digital-marketing-internship" class="subnav-link">Digital Marketing</router-link></li>
            <li style="margin:10px 0;"><router-link to="/social-media-marketing-internship" class="subnav-link">Social Media Marketing</router-link></li>
            <li style="margin:10px 0;"><router-link to="/content-creation-internship" class="subnav-link">Content Creation and Copywriting</router-link></li>
            <li style="margin:10px 0;"><router-link to="/website-design-internship" class="subnav-link">Website Design</router-link></li>
            <li style="margin:10px 0;"><router-link to="/data-analytics-internship" class="subnav-link">Data Analytics and BI</router-link></li>
            <li style="margin:10px 0;"><router-link to="/graphic-design-internship" class="subnav-link">Graphic Design</router-link></li>
            </ul>
            <div style="margin-top:18px;">
            <router-link to="/who-we-serve" class="subnav-link" style="font-size:1.05em;">Back to All Programs</router-link>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: "ContentCreationInternship",
  methods: {
    onProgramChange(event) {
      const path = event.target.value;
      if (path && path !== this.$route.path) {
        this.$router.push(path);
      }
    }
  }
};
</script>

<style scoped>
.subnav-link {
  margin: 0 10px;
  color: #BF00FF;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
}
.subnav-link:hover {
  color: #7a4fa3;
  text-decoration: underline;
}
.subnav-link.router-link-exact-active {
  text-decoration: underline;
  font-weight: bold;
}
.button-row {
  display: flex;
  gap: 16px;
  justify-content: center;
  align-items: center;
  margin-bottom: 1em;
}
.button-row a {
  display: inline-block;
}
.explore-programs-dropdown {
  margin: 40px auto 0 auto;
  max-width: 600px;
  text-align: center;
  padding: 24px 16px 18px 16px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px 0 rgba(191,0,255,0.04);
}
.dropdown-label {
  font-weight: 600;
  color: #7a4fa3;
  font-size: 1.1rem;
  margin-bottom: 10px;
  display: block;
}
.program-select {
  width: 100%;
  max-width: 420px;
  padding: 12px 16px;
  font-size: 1.08rem;
  border: 1.5px solid #BF00FF;
  border-radius: 8px;
  background: #f7f2fa;
  color: #41037b;
  font-weight: 500;
  outline: none;
  transition: border 0.2s;
  margin: 0 auto;
  box-shadow: 0 1px 4px 0 rgba(122,79,163,0.04);
}
.program-select:focus {
  border: 2px solid #7a4fa3;
}
@media (max-width: 600px) {
  .button-row {
    flex-direction: column;
    gap: 8px;
  }
  .explore-programs-dropdown {
    padding: 16px 4px 12px 4px;
  }
  .program-select {
    font-size: 1em;
    padding: 10px 8px;
    max-width: 100%;
  }
}
</style>
